<template v-slot:error>
  <div class="error-placeholder">
    <van-icon name="fail" />
  </div>
</template>

<script>
import Vue from 'vue';
import { Icon } from 'vant';

Vue.use(Icon);

export default {
  name: 'ImageLoading',
  components: {},
};
</script>
